__turbopack_context__.v({
  "producerName": "JxngMa_producerName",
  "productDetails": "JxngMa_productDetails",
  "productName": "JxngMa_productName",
  "productUnitDetails": "JxngMa_productUnitDetails",
  "webContent": "JxngMa_webContent",
});
